require('./mortgageRequestDateOfBirthForm.scss');
require('./mortgageRequestDateOfBirthForm.override.scss');

//@vendor
const React = require('react');
const PropTypes = require('prop-types');
const className = require('classnames');
const set = require('lodash/object/set');

// @core
const { formatText, FormattedText } = require('core/i18n').i18n;

//@commons
const { OKBoxTitle } = require('commonsComponents/OKBoxTitle');
const { InputSafe } = require('commonsComponents/inputSafe');

// @constants
const { HOLDER_OPTION_ONE, HOLDER_OPTION_TWO } = require('constants/mortgageRequestPreApproval').mortgageRequestPreApprovalCommons;
const { NON_NUMERIC_REGEXP } = require('constants/index');

class MortgageRequestDateOfBirthForm extends React.Component {
    constructor(props) {
        super(props);

        this.inputs = {
            holderOneDay: {},
            holderOneMonth: {},
            holderOneYear: {}
        };

        this.mapInitialState(this, props);
        this.handleChange = this.handleChange.bind(this);
        this.handleBlur = this.handleBlur.bind(this);
    }

    mapInitialState(context, props) {
        const { immMortgageRequest } = props;
        const holderOneInfo = immMortgageRequest.getIn(['holders', HOLDER_OPTION_ONE]);
        const holderTwoInfo = immMortgageRequest.getIn(['holders', HOLDER_OPTION_TWO]);

        context.state = {
            holders: [
                {
                    dayOfBirth: holderOneInfo.get('dayOfBirth'),
                    monthOfBirth: holderOneInfo.get('monthOfBirth'),
                    yearOfBirth: holderOneInfo.get('yearOfBirth'),
                    validDate: true,
                    legalAge: true
                },
                {
                    dayOfBirth: holderTwoInfo.get('dayOfBirth'),
                    monthOfBirth: holderTwoInfo.get('monthOfBirth'),
                    yearOfBirth: holderTwoInfo.get('yearOfBirth'),
                    validDate: true,
                    legalAge: true
                }
            ]
        };
    }

    updateHoldersDateValidityData(holders, holderDateValidity, currentHolder) {
        const holdersCopy = [...holders];

        if (holderDateValidity.validDate && holderDateValidity.legalAge || holderDateValidity.emptyDate) {
            holdersCopy[currentHolder].validDate = true;
            holdersCopy[currentHolder].legalAge = false;
        } else if (holderDateValidity.validDate && !holderDateValidity.legalAge) {
            holdersCopy[currentHolder].validDate = false;
            holdersCopy[currentHolder].legalAge = true;
        } else if (!holderDateValidity.legalAge && !holderDateValidity.validDate) {
            holdersCopy[currentHolder].validDate = false;
            holdersCopy[currentHolder].legalAge = false;
        }

        return holdersCopy;
    }

    handleBlur({ target: { value, name } }) {
        const { formHandlers, getDateValidity, setTemporalHolderBirthDates } = this.props;
        const {
            handleHolderDayOfBirthChange,
            handleHolderMonthOfBirthChange,
            handleHolderYearOfBirthChange
        } = formHandlers;
        const formattedValue = value.replace(NON_NUMERIC_REGEXP, '').trim();
        let currentHolder = HOLDER_OPTION_ONE;
        let holders = [...this.state.holders];

        if (name !== 'holderOneDay' && name !== 'holderOneMonth' && name !== 'holderOneYear') {
            currentHolder = HOLDER_OPTION_TWO;
        }

        switch (name) {
            case 'holderOneDay':
            case 'holderTwoDay':
                holders[currentHolder].dayOfBirth = formattedValue;
                break;
            case 'holderOneMonth':
            case 'holderTwoMonth':
                holders[currentHolder].monthOfBirth = formattedValue;
                break;
            case 'holderOneYear':
            case 'holderTwoYear':
                holders[currentHolder].yearOfBirth = formattedValue.replace(/^0+/, '');
                break;
        }
        const { dayOfBirth, monthOfBirth, yearOfBirth } = holders[currentHolder];
        const holderDateValidity = getDateValidity(dayOfBirth, monthOfBirth, yearOfBirth);
        holders = this.updateHoldersDateValidityData(holders, holderDateValidity, currentHolder);

        if (holderDateValidity.isEmpty || (holderDateValidity.validDate && holderDateValidity.legalAge)) {
            handleHolderDayOfBirthChange(dayOfBirth, currentHolder);
            handleHolderMonthOfBirthChange(monthOfBirth, currentHolder);
            handleHolderYearOfBirthChange(yearOfBirth, currentHolder);
        }

        setTemporalHolderBirthDates(holders)
        this.setState({ holders });
    }

    handleChange({ target: { value, name } }) {
        const formattedValue = value.replace(NON_NUMERIC_REGEXP, '').trim();
        let currentHolder = HOLDER_OPTION_ONE;
        let holders = [...this.state.holders];
        const { getDateValidity } = this.props;

        if (name !== 'holderOneDay' && name !== 'holderOneMonth' && name !== 'holderOneYear') {
            currentHolder = HOLDER_OPTION_TWO;
        }

        switch (name) {
            case 'holderOneDay':
                holders[currentHolder].dayOfBirth = formattedValue;
                formattedValue.length === 2 && this.inputs.holderOneMonth.el.focus();
                break;
            case 'holderTwoDay':
                holders[currentHolder].dayOfBirth = formattedValue;
                formattedValue.length === 2 && this.inputs.holderTwoMonth.el.focus();
                break;
            case 'holderOneMonth':
                holders[currentHolder].monthOfBirth = formattedValue;
                formattedValue.length === 2 && this.inputs.holderOneYear.el.focus();
                break;
            case 'holderTwoMonth':
                holders[currentHolder].monthOfBirth = formattedValue;
                formattedValue.length === 2 && this.inputs.holderTwoYear.el.focus();
                break;
            case 'holderOneYear':
            case 'holderTwoYear':
                holders[currentHolder].yearOfBirth = formattedValue.replace(/^0+/, '');
                break;
        }

        const { dayOfBirth, monthOfBirth, yearOfBirth } = holders[currentHolder];
        const holderDateValidity = getDateValidity(dayOfBirth, monthOfBirth, yearOfBirth);
        holders = this.updateHoldersDateValidityData(holders, holderDateValidity, currentHolder);

        this.setState({ holders });
    }

    everyFieldIsFilled({ dayOfBirth = '', monthOfBirth = '', yearOfBirth = '' }) {
        const NUMBER_OF_CHARACTERS_OF_A_YEAR = 4;
        const day = `${dayOfBirth}`;
        const month = `${monthOfBirth}`;
        const year = `${yearOfBirth}`;
        const holderIsCompletlyFilled = (
            day.length > 0 && month.length > 0 &&
            year.length === NUMBER_OF_CHARACTERS_OF_A_YEAR
        );
        return holderIsCompletlyFilled;
    }

    buildHolderOneFields() {
        const { immMortgageRequest, validModal, isClientWithoutAccounts } = this.props;
        const selectedHolder = immMortgageRequest.get('selectedHolder');
        const holderOne = this.state.holders[HOLDER_OPTION_ONE];
        const { validDate, legalAge } = holderOne;
        const valid = validModal.getIn(['fields', HOLDER_OPTION_ONE, 'filled'], true);
        const validated = immMortgageRequest.getIn(['validModals', 'validated'], true);
        const valueErrDate = legalAge ? 'mortgageRequestPreApprovalStepThree-mortgageRequestPreApprovalStepThree_invalidDateYoungerEighteen' : 'mortgageRequestPreApprovalStepThree-mortgageRequestPreApprovalStepThree_dateError';
        const customClass = className('col-md-4', { 'col-md-6': selectedHolder === HOLDER_OPTION_ONE });
        const customClassTitle = className('mortgage-request-date-of-birth-form__input-field-title',
            { 'mortgage-request-date-of-birth-form__input-field-title--hidden': selectedHolder === HOLDER_OPTION_ONE });
        const errorClass = className({
            'mortgage-request-date-of-birth-form__input-field--error': !validDate,
            'mortgage-request-date-of-birth-form__input-field--hidden': validDate
        });
        const containerClass = className('mortgage-request-date-of-birth-form__container-fields', {
            'mortgage-request-date-of-birth-form__container-fields--error': !valid && validated
        });
        const error = (
            this.everyFieldIsFilled(holderOne) &&
            <FormattedText className={errorClass} value={valueErrDate} />
        );

        return (
            <div className={customClass}>
                <FormattedText
                    className={customClassTitle}
                    value="mortgageRequestPreApprovalStepThree-firstOwner" />
                <div className={containerClass}>
                    <div className="mortgage-request-date-of-birth-form__input-field">
                        <InputSafe
                            name="holderOneDay"
                            autoFocus="true"
                            autoComplete="off"
                            onChange={this.handleChange}
                            onBlur={this.handleBlur}
                            ref={input => set(this.inputs, "holderOneDay", input)}
                            placeholder="DD"
                            maxLength={2}
                            value={holderOne.dayOfBirth}
                            disabled={!isClientWithoutAccounts}
                        />
                    </div>
                    <div className="mortgage-request-date-of-birth-form__input-field">
                        <InputSafe
                            name="holderOneMonth"
                            autoComplete="off"
                            onBlur={this.handleBlur}
                            onChange={this.handleChange}
                            ref={input => set(this.inputs, "holderOneMonth", input)}
                            placeholder="MM"
                            maxLength={2}
                            value={holderOne.monthOfBirth}
                            disabled={!isClientWithoutAccounts}
                        />
                    </div>
                    <div className="mortgage-request-date-of-birth-form__input-field-large">
                        <InputSafe
                            name="holderOneYear"
                            autoComplete="off"
                            onBlur={this.handleBlur}
                            onChange={this.handleChange}
                            ref={input => set(this.inputs, "holderOneYear", input)}
                            placeholder="AAAA"
                            maxLength={4}
                            value={holderOne.yearOfBirth}
                            disabled={!isClientWithoutAccounts}
                        />
                    </div>
                </div>
                {error}
            </div>
        );
    }

    buildHolderTwoFields() {
        const { validModal, immMortgageRequest } = this.props;
        const holderTwo = this.state.holders[HOLDER_OPTION_TWO];
        const { validDate, legalAge } = holderTwo;
        const valid = validModal.getIn(['fields', HOLDER_OPTION_TWO, 'filled'], true);
        const validated = immMortgageRequest.getIn(['validModals', 'validated'], true);
        const valueErrDate = legalAge ? "mortgageRequestPreApprovalStepThree-mortgageRequestPreApprovalStepThree_invalidDateYoungerEighteen" : "mortgageRequestPreApprovalStepThree-mortgageRequestPreApprovalStepThree_dateError"

        const errorClass = className({
            'mortgage-request-date-of-birth-form__input-field--error': !validDate,
            'mortgage-request-date-of-birth-form__input-field--hidden': validDate,
        });
        const containerClass = className('mortgage-request-date-of-birth-form__container-fields', {
            'mortgage-request-date-of-birth-form__container-fields--error': !valid && validated
        });
        const error = (
            this.everyFieldIsFilled(holderTwo) &&
            <FormattedText className={errorClass} value={valueErrDate} />
        );

        return (
            <div className="col-md-4">
                <FormattedText
                    className="mortgage-request-date-of-birth-form__input-field-title"
                    value="mortgageRequestPreApprovalStepThree-secondOwner" />
                <div className={containerClass}>
                    <div className="mortgage-request-date-of-birth-form__input-field">
                        <InputSafe
                            name="holderTwoDay"
                            autoComplete="off"
                            onBlur={this.handleBlur}
                            onChange={this.handleChange}
                            ref={input => set(this.inputs, "holderTwoDay", input)}
                            placeholder="DD"
                            maxLength={2}
                            value={holderTwo.dayOfBirth}
                        />
                    </div>
                    <div className="mortgage-request-date-of-birth-form__input-field">
                        <InputSafe
                            name="holderTwoMonth"
                            autoComplete="off"
                            onBlur={this.handleBlur}
                            onChange={this.handleChange}
                            ref={input => set(this.inputs, "holderTwoMonth", input)}
                            placeholder="MM"
                            maxLength={2}
                            value={holderTwo.monthOfBirth}
                        />
                    </div>
                    <div className="mortgage-request-date-of-birth-form__input-field-large">
                        <InputSafe
                            name="holderTwoYear"
                            autoComplete="off"
                            onBlur={this.handleBlur}
                            onChange={this.handleChange}
                            ref={input => set(this.inputs, "holderTwoYear", input)}
                            placeholder="AAAA"
                            maxLength={4}
                            value={holderTwo.yearOfBirth}
                        />
                    </div>
                </div>
                {error}
            </div>
        );
    }

    render() {
        const { immMortgageRequest } = this.props;
        const selectedHolder = immMortgageRequest.get('selectedHolder');
        const holderOneFields = this.buildHolderOneFields();
        const holderTwoFields = selectedHolder === HOLDER_OPTION_ONE ? null : this.buildHolderTwoFields();
        const customClass = className('col-md-4 mortgage-request-date-of-birth-form__label',
            { 'col-md-6 mortgage-request-date-of-birth-form__label--small': selectedHolder === HOLDER_OPTION_ONE });
        const customBodyClass = className('col-md-12 mortgage-request-date-of-birth-form__body',
            { 'col-md-12 mortgage-request-date-of-birth-form__body--large': selectedHolder === HOLDER_OPTION_TWO });

        return (
            <div className="row mortgage-request-date-of-birth-form">
                <div className="col-md-11">
                    <OKBoxTitle value={formatText('mortgageRequestPreApprovalStepThree-birthDate')} size="medium" />
                </div>
                <div className={customBodyClass}>
                    <div className="row">
                        <div className={customClass}>
                            <FormattedText value="mortgageRequestPreApprovalStepThree-birthDateInput" />
                        </div>
                        {holderOneFields}
                        {holderTwoFields}
                    </div>
                </div>
            </div >
        );
    }
}

MortgageRequestDateOfBirthForm.propTypes = {
    immMortgageRequest: PropTypes.object.isRequired,
    formHandlers: PropTypes.object.isRequired,
    validModal: PropTypes.object.isRequired,
    isClientWithoutAccounts: PropTypes.bool.isRequired,
    getDateValidity: PropTypes.func.isRequired,
    setTemporalHolderBirthDates: PropTypes.func.isRequired
}

module.exports = MortgageRequestDateOfBirthForm;
